export const ErrorInfoType = Object.freeze({
    CoreError: 'CoreError', // goodt-wcore usage error
    CoreWarning: 'CoreWarning', // goodt-wcore usage error
    WidgetDebug: 'WidgetDebug', // goodt-wcore usage error
    DremioError: 'DremioError', // Dremio service usage error
    ApiServiceError: 'ApiServiceError', // Api service usage error
    InfrastructureError: 'InfrastructureError', // Generally Infrastructure error in Transport or Client
    ServerError: 'ServerError', // Transport error with 500 status code
    SilentError: 'SilentError' // SilentError should not be handled, used as signal or to represent
});
